import PatientResidentRegistrationNumberView from './PatientResidentRegistrationNumberView';
import { PatientResidentRegistrationNumberProvider } from '@context/PatientResidentRegistrationNumber';
const PatientResidentRegistrationNumberInput = () => {
  return (
    <PatientResidentRegistrationNumberProvider>
      <PatientResidentRegistrationNumberView />
    </PatientResidentRegistrationNumberProvider>
  );
};

export default PatientResidentRegistrationNumberInput;
